var _defs, _path, _path2, _path3, _polygon;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovapointTerrainShapingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#72a544;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointTerrainShaping_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.72,13.29a17.29,17.29,0,0,1-10,.27,20.86,20.86,0,0,1-2.4-1C15.18,12,14.54,11.77,14,12s-.6.5-.93,1.38a5.92,5.92,0,0,1-1.84,2.84,6.16,6.16,0,0,1-2.64,1.13l2.12,1.05c2.32-2.23,4.5-3.27,6.49-3.07a8,8,0,0,1,2.46.77,7.82,7.82,0,0,0,3.39.85h0a7.53,7.53,0,0,0,1.56-.17L30.16,14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.82,17.91A6.41,6.41,0,0,0,17,17.3c-1.26-.12-2.73.56-4.38,2L16,21l4.79-2.38A12.62,12.62,0,0,1,18.82,17.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.94,14.63a4.13,4.13,0,0,0,1.22-2,3.69,3.69,0,0,1,2.12-2.55c1.37-.5,2.61.07,3.91.67a19.12,19.12,0,0,0,2.17.88,13.85,13.85,0,0,0,6.56.25L16,7,1.84,14l2.77,1.37C7.09,15.72,8.88,15.47,9.94,14.63Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32 24 28 24 28 20 24 20 24 24 20 24 20 28 24 28 24 32 28 32 28 28 32 28 32 24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointTerrainShapingSvg);
export default __webpack_public_path__ + "static/media/NovapointTerrainShaping_svg.236167aa3f88c39ebac7d9b8cfbca021.svg";
export { ForwardRef as ReactComponent };